<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M12 18.7815C18.6274 18.7815 24 14.5771 24 9.39074C24 4.20438 18.6274 0 12 0C5.37258 0 0 4.20438 0 9.39074C0 12.1976 1.76098 14.6571 4.06799 16.4376C6.375 18.218 7.46707 21.84 8.1032 23.7342C8.21753 24.0746 8.71158 24.0935 8.84282 23.7593L10.815 18.7364L10.8143 18.7362C11.2043 18.7662 11.5999 18.7815 12 18.7815Z"
        fill="#111827"
    />
</svg>
